import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export function LoginPage() {
  const { user, authRequired, signIn } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  // If auth isn't required (dev) or already signed in, go to the app.
  if (!authRequired || user) return <Navigate to="/" replace />;

  const onSignIn = async () => {
    setBusy(true);
    setError(null);
    try {
      await signIn();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="centered">
      <div className="login-card">
        <h1>Aura Admin</h1>
        <p className="muted">Sign in with your Aura Google account to continue.</p>
        <button className="btn btn-primary" onClick={onSignIn} disabled={busy}>
          {busy ? "Signing in…" : "Sign in with Google"}
        </button>
        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
}
